import { v4 as uuidv4 } from 'uuid';

import { ModalLayout } from '../../../../vtex-apps/modal-layout/ModalLayout/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ModalHeader } from '../../../../vtex-apps/modal-layout/ModalHeader/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { NewsletterForm } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { ModalActionsClose } from '../../../../vtex-apps/modal-layout/ModalActions/default';
import { ModalTrigger } from '../../../../vtex-apps/modal-layout/ModalTrigger/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { NewsletterCheckboxConfirmation } from '../../../../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/default';

export default function Newsletter() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ModalNewsletter',
		props: VisibilityLayout({ mzTitle: 'Visibilidade Modal Newsletter (On/Off)' }).props,
		variables,
		childrenComponents: [
			ModalTrigger(
				{
					trigger: 'load-session',
					blockClass: 'modal-trigger-newsletter-1',
					mzTitle: 'MZ | Modal Smartnewsletter',
				},
				[
					ModalLayout(
						{
							blockClass: 'modal-layout-newsletter-1',
						},
						[
							FlexLayoutRow(
								{
									blockClass: 'flex-row__modal-header-1',
								},
								[
									ModalHeader({
										iconCloseSize: 20,
										blockClass: 'modal-header-newsletter-1',
									}),
								],
							),
							FlexLayoutRow(
								{
									blockClass: 'flex-row__modal-newsletter-content-1',
								},
								[
									FlexLayoutCol(
										{
											blockClass: 'flex-col__newsletter-img-1',
										},
										[
											Image({
												blockClass: 'modal-newsletter-img-1',
												src: 'https://hefesto-upload-images.s3.amazonaws.com/1682440801068-placeholder-newsletter-desktop.png',
											}),
										],
									),
									FlexLayoutCol(
										{
											blockClass: 'flex-col__newsletter-form-1',
											preventVerticalStretch: true,
										},
										[
											Image({
												blockClass: 'modal-newsletter-icon-1',
												src: 'https://hefesto-upload-images.s3.amazonaws.com/1682440921828-placeholder-newsletter-logo.png',
											}),
											RichText({
												mzTitle: 'MZ | Título',
												blockClass: 'modal-newsletter-title-1',
												text: 'Bem Vindo!',
											}),
											RichText({
												mzTitle: 'MZ | Subtítulo',
												blockClass: 'modal-newsletter-subtitle-1',
												text: '**Receba em primeira mão desconto e ofertas exclusivas**',
											}),
											NewsletterForm(
												{
													blockClass: 'modal-newsletter-form-1',
													SuccessState: FlexLayoutRow(
														{
															blockClass: 'flex-row__modal-success-1',
														},
														[
															FlexLayoutCol(
																{
																	blockClass: 'flex-col__modal-success-1',
																	preventVerticalStretch: true,
																},
																[
																	Image({
																		blockClass: 'modal-newsletter-icon-1',
																		src: 'https://hefesto-upload-images.s3.amazonaws.com/1682440921828-placeholder-newsletter-logo.png',
																	}),
																	RichText({
																		mzTitle: 'MZ | Mensagem de sucesso',
																		text: 'Em breve, você receberá em seu e-mail nossas ofertas e descontos exclusivos.',
																		blockClass: 'modal-newsletter-success-1',
																	}),
																	ModalActionsClose({
																		blockClass: 'modal-newsletter-close-1',
																		label: 'Fechar',
																	}),
																],
															),
														],
													),
												},
												[
													NewsletterInputEmail({
														blockClass: 'modal-newsletter-email-1',
														placeholderText: 'Seu email favorito',
													}),
													//modal
													FlexLayoutRow(
														{
															blockClass: 'modal-inner-row__newsletter-1',
														},
														[
															NewsletterCheckboxConfirmation({
																blockClass: 'modal-1',
																checkboxLabel: ' ',
															}),
															RichText({
																mzTitle: 'MZ | Newsletter modal - políticas',
																text: 'Concordo com a [Política de Privacidade](/politica-de-privacidade)',
																blockClass: ['newsletter__help-message-modal-1'],
															}),
														],
													),
													NewsletterSubmit({
														blockClass: 'modal-newsletter-submit-1',
														submitButtonLabel: 'Enviar',
													}),
												],
											),
										],
									),
								],
							),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--mn-1-bg-color', name: 'Background' },
			{ from: '--black', to: '--mn-1-title-color', name: 'Title' },
			{ from: '--black', to: '--mn-1-subtitle-color', name: 'Subtitle' },
			{ from: '--neutral-color-low-light', to: '--mn-1-input-border-color', name: 'Input Border' },
			{ from: '--text-color-1', to: '--mn-1-input-text-color', name: 'Input Text' },
			{ from: '--white', to: '--mn-1-cta-text-color', name: 'CTA Text' },
			{ from: '--brand-color-primary-pure', to: '--mn-1-cta-close-color', name: 'Close Button' },
			{ from: '--brand-color-primary-pure', to: '--mn-1-nl-success-color', name: 'Newsletter Success' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--mn-1-border-radius', name: 'CTA Border Radius' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--mn-1-title-size', name: 'Title' },
			{ from: '--font-size-md', to: '--mn-1-subtitle-size', name: 'Subtitle' },
			{ from: '--font-size-sm', to: '--mn-1-input-size', name: 'Input Text' },
			{ from: '--font-size-sm', to: '--mn-1-cta-size', name: 'CTA Text' },
			{ from: '--font-size-lg', to: '--mn-1-nl-success-size', name: 'Newsletter Success' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--mn-1-title-font', name: 'Title' },
			{ from: '--main-font', to: '--mn-1-subtitle-font', name: 'Subtitle' },
			{ from: '--main-font', to: '--mn-1-input-font', name: 'Input' },
			{ from: '--main-font', to: '--mn-1-cta-font', name: 'CTA' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-500', to: '--mn-1-title-weight', name: 'Title' },
			{ from: '--font-weight-700', to: '--mn-1-subtitle-weight', name: 'Subtitle' },
			{ from: '--font-weight-500', to: '--mn-1-input-weight', name: 'Input' },
			{ from: '--font-weight-700', to: '--mn-1-cta-weight', name: 'CTA' },
			{ from: '--font-weight-500', to: '--mn-1-success-weight', name: 'Success Text' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-sm', to: '--mn-1-input-height', name: 'Input' },
			{ from: '--spacing-sm', to: '--mn-1-cta-height', name: 'CTA' },
		],
	},
];
